import { useState } from 'react';
import TabContext from './tabsContext';
import { TabsProps } from './tabTypes';

const Tabs: React.FC<TabsProps> = ({ children, defaultTab, tabIndex, setTabIndex }) => {
    const [index, setIndex] = useState(defaultTab ?? 0);

    return (
        <TabContext.Provider
            value={{
                tabIndex: tabIndex ?? index,
                setTabIndex: setTabIndex ?? setIndex,
            }}
        >
            {children}
        </TabContext.Provider>
    );
};

export default Tabs;
